import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {IconComponent, IconName} from '@adnova/jf-ng-components';


export interface SnackbarData {
  message: string;
  icon?: IconName;
  iconSize?: number;
  iconStrokeWidth?: number;
}

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss']
})
export class CustomSnackbarComponent {
  protected data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
}
